<button aria-label="Close sidebar" on:click class="gw-drawer-backdrop" />

<style>
    .gw-drawer-backdrop {
        display: table;
        position: fixed;
        z-index: 1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--gw-drawer-sidebar-backdrop-bg);
        border: none;
    }
</style>
